import { ErrorOutline } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { useSubscription } from "src/context/SubscriptionProvider";
import { usePatientLocale } from "src/hooks/usePatientLocale";
import WhiteCard from "src/shared/components/WhiteCard";

const Breakdown = () => {
  const { t } = useTranslation();
  const page = "cancellationReview";
  const locale = usePatientLocale();
  const periodEnd = useSubscription((s) => {
    if (s.current_period_end == null) return "";

    const dateFormat = locale === enUS ? "MM/dd" : "dd/MM";

    return format(new Date(s.current_period_end), dateFormat, { locale });
  });
  const breakdown = [
    {
      text: `${page}.breakdown.text.0`,
      subtext: `${page}.breakdown.subtext.0`,
    },
    {
      text: `${page}.breakdown.text.1`,
      subtext: `${page}.breakdown.subtext.1`,
    },
    {
      text: `${page}.breakdown.text.2`,
      subtext: `${page}.breakdown.subtext.2`,
    },
  ];

  return (
    <WhiteCard gap={2}>
      {breakdown.map((item, idx) => (
        <Stack key={idx}>
          <Stack direction={"row"} gap={1}>
            <ErrorOutline />
            <Typography fontWeight={700}>
              {t(item.text, { periodEnd })}
            </Typography>
          </Stack>
          <Typography variant="subtitle1">{t(item.subtext)}</Typography>
        </Stack>
      ))}
    </WhiteCard>
  );
};

export default Breakdown;
